(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[27,36837,61971,59654,55004,6050,12701,54223,59679],{

/***/ 36837:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ components_SectionTitle; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./UI/components/Typography/index.jsx
var Typography = __webpack_require__(59654);
// EXTERNAL MODULE: ./UI/components/Typography/utils/useTypography.js
var useTypography = __webpack_require__(18422);
// EXTERNAL MODULE: ./UI/components/SectionTitle/styles.module.scss
var styles_module = __webpack_require__(89494);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/components/SectionTitle/utils/get-segment-text.js

var getSegmentText = function(text) {
    var parts = text.split(/(~~.*?~~)/g);
    return parts.map(function(part) {
        var isAlpa = /^~~.*~~$/.test(part);
        if (isAlpa) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                "data-title-alpha": true,
                style: {
                    display: "inline"
                },
                children: part.slice(2, -2)
            }, part);
        }
        return part;
    });
};

;// CONCATENATED MODULE: ./UI/components/SectionTitle/index.jsx











var Animated = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 61971).then(__webpack_require__.bind(__webpack_require__, 61971));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(61971)
            ];
        }
    }
});
var SectionTitle = function(param) {
    var type = param.type, titleStyle = param.titleStyle, title = param.title, titleVariant = param.titleVariant, secondTitle = param.secondTitle, secondTitleVariant = param.secondTitleVariant, subtitle = param.subtitle, secondSubtitle = param.secondSubtitle, description = param.description, secondDescription = param.secondDescription, className = param.className, children = param.children;
    var titleSegments = title === null || title === void 0 ? void 0 : title.split("||");
    var descriptionParagraphs = description === null || description === void 0 ? void 0 : description.split("||");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((styles_module_default()).sectionTitleContainer, (styles_module_default())[type], className, titleStyle),
        children: [
            title && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 50,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-title": true,
                    isBold: true,
                    size: useTypography/* TYPOGRAPHY_SIZE.headline38 */.y3.headline38,
                    mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                    variant: titleVariant,
                    className: (styles_module_default()).title,
                    children: titleSegments.length === 1 ? getSegmentText(title) : titleSegments.map(function(segment) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                            ket: segment,
                            "data-title": true,
                            isBold: true,
                            size: useTypography/* TYPOGRAPHY_SIZE.headline38 */.y3.headline38,
                            mobileSize: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                            variant: "span",
                            className: (styles_module_default()).title,
                            children: getSegmentText(segment)
                        });
                    })
                })
            })),
            subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 100,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-subtitle": true,
                    size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                    className: (styles_module_default()).subtitle,
                    children: subtitle
                })
            })),
            descriptionParagraphs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 100,
                children: descriptionParagraphs === null || descriptionParagraphs === void 0 ? void 0 : descriptionParagraphs.map(function(text, index) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                        "data-description": true,
                        size: useTypography/* TYPOGRAPHY_SIZE.paragrapgh16 */.y3.paragrapgh16,
                        className: (styles_module_default()).description,
                        children: text
                    }, "paragraph/".concat(index));
                })
            })),
            secondTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 150,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    isBold: true,
                    "data-second-title": true,
                    size: useTypography/* TYPOGRAPHY_SIZE.headline24 */.y3.headline24,
                    variant: secondTitleVariant,
                    className: (styles_module_default()).title,
                    children: secondTitle
                })
            })),
            secondSubtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-second-subtitle": true,
                    className: (styles_module_default()).subtitle,
                    children: secondSubtitle
                })
            })),
            secondDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                transitionDelay: 200,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography["default"], {
                    "data-second-description": true,
                    className: (styles_module_default()).description,
                    children: secondDescription
                })
            })),
            children
        ]
    });
};
SectionTitle.defaultProps = {
    type: "default",
    titleStyle: "",
    subtitle: "",
    description: null,
    className: null,
    title: null,
    secondTitle: "",
    secondSubtitle: "",
    secondDescription: "",
    titleVariant: "h2",
    secondTitleVariant: "h3"
};
SectionTitle.propTypes = {
    type: (prop_types_default()).string,
    titleStyle: (prop_types_default()).string,
    title: (prop_types_default()).string,
    secondTitle: (prop_types_default()).string,
    subtitle: (prop_types_default()).string,
    secondSubtitle: (prop_types_default()).string,
    description: (prop_types_default()).string,
    secondDescription: (prop_types_default()).string,
    className: (prop_types_default()).string,
    titleVariant: (prop_types_default()).string,
    secondTitleVariant: (prop_types_default()).string
};
/* harmony default export */ var components_SectionTitle = (SectionTitle);


/***/ }),

/***/ 59654:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(45697);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(18422);






var Typography = function(props) {
    var _ref = (0,_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .useTypography */ .tj)(props), Tag = _ref.Tag, classes = _ref.classes, children = _ref.children, onClick = _ref.onClick, tabIndex = _ref.tabIndex, role = _ref.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_ref, [
        "Tag",
        "classes",
        "children",
        "onClick",
        "tabIndex",
        "role"
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Tag, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        className: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest), {
        children: children
    }));
};
Typography.defaultProps = {
    variant: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_TAGS.p */ .w1.p,
    size: _utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE.paragrapgh16 */ .y3.paragrapgh16
};
Typography.propTypes = {
    children: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().node.isRequired),
    isBold: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().bool),
    variant: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    className: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    size: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    mobileSize: prop_types__WEBPACK_IMPORTED_MODULE_5___default().oneOf(Object.values(_utils_useTypography__WEBPACK_IMPORTED_MODULE_1__/* .TYPOGRAPHY_SIZE */ .y3)),
    onClick: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().func),
    tabIndex: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string),
    role: (prop_types__WEBPACK_IMPORTED_MODULE_5___default().string)
};
/* harmony default export */ __webpack_exports__["default"] = (Typography);


/***/ }),

/***/ 18422:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "tj": function() { return /* binding */ useTypography; },
/* harmony export */   "w1": function() { return /* binding */ TYPOGRAPHY_TAGS; },
/* harmony export */   "y3": function() { return /* binding */ TYPOGRAPHY_SIZE; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(99534);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2664);
/* harmony import */ var redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19341);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(34461);
/* harmony import */ var _styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_styles_module_scss__WEBPACK_IMPORTED_MODULE_4__);







var TYPOGRAPHY_TAGS = {
    h1: "h1",
    h2: "h2",
    h3: "h3",
    h4: "h4",
    h5: "h5",
    h6: "h6",
    p: "p",
    span: "span"
};
var TYPOGRAPHY_SIZE = {
    caption12: "caption",
    paragrapgh14: "paragrapgh-s",
    paragrapgh16: "paragrapgh-m",
    headline20: "headline-xs",
    headline24: "headline-s",
    headline38: "headline-m",
    headline46: "headline-l",
    headline56: "headline-xl"
};
var useTypography = function(_param) {
    var variant = _param.variant, isBold = _param.isBold, className = _param.className, children = _param.children, size = _param.size, mobileSize = _param.mobileSize, onClick = _param.onClick, tabIndex = _param.tabIndex, role = _param.role, rest = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(_param, [
        "variant",
        "isBold",
        "className",
        "children",
        "size",
        "mobileSize",
        "onClick",
        "tabIndex",
        "role"
    ]);
    var isDesktopResolution = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__.useSelector)(redux_selectors_layout__WEBPACK_IMPORTED_MODULE_3__/* .selectIsDesktop */ .Y6);
    var Tag = TYPOGRAPHY_TAGS[variant] || variant;
    var actualSize = isDesktopResolution || !mobileSize ? size : mobileSize;
    var classes = classnames__WEBPACK_IMPORTED_MODULE_0___default()((_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().typography), className, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default())[actualSize], (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, (_styles_module_scss__WEBPACK_IMPORTED_MODULE_4___default().boldText), isBold));
    return (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        Tag: Tag,
        children: children,
        classes: classes,
        onClick: onClick,
        tabIndex: tabIndex,
        role: role
    }, rest);
};


/***/ }),

/***/ 61971:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var utils_constants__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(96076);
/* eslint-disable react/destructuring-assignment */ 




var ScrollAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 71317).then(__webpack_require__.t.bind(__webpack_require__, 71317, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(71317)
            ];
        }
    }
});
var Reveal = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 8365).then(__webpack_require__.t.bind(__webpack_require__, 8365, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(8365)
            ];
        }
    }
});
var Fade = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 19470).then(__webpack_require__.t.bind(__webpack_require__, 19470, 23)).then(function(module) {
        return module.default;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(19470)
            ];
        }
    }
});
var CSSAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 90959).then(__webpack_require__.bind(__webpack_require__, 90959)).then(function(module) {
        return module.CSSAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(90959)
            ];
        }
    }
});
var ImageZoom = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 16626).then(__webpack_require__.bind(__webpack_require__, 16626));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(16626)
            ];
        }
    }
});
var Gsap = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94744).then(__webpack_require__.bind(__webpack_require__, 94744)).then(function(module) {
        return module.Gsap;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94744)
            ];
        }
    }
});
var ParallaxWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(11897)]).then(__webpack_require__.bind(__webpack_require__, 11897));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(11897)
            ];
        }
    }
});
var ExpandWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 68376).then(__webpack_require__.bind(__webpack_require__, 68376)).then(function(module) {
        return module.ExpandWrapper;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(68376)
            ];
        }
    }
});
var CustomAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 52612).then(__webpack_require__.bind(__webpack_require__, 52612)).then(function(module) {
        return module.CustomAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(52612)
            ];
        }
    }
});
var JSONAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(51028), __webpack_require__.e(69255), __webpack_require__.e(25845)]).then(__webpack_require__.bind(__webpack_require__, 25845)).then(function(module) {
        return module.JSONAnimation;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(25845)
            ];
        }
    }
});
var Bounce = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return __webpack_require__.e(/* import() */ 94803).then(__webpack_require__.t.bind(__webpack_require__, 94803, 23));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(94803)
            ];
        }
    }
});
var CounterAnimation = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(78162)]).then(__webpack_require__.bind(__webpack_require__, 78162));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(78162)
            ];
        }
    }
});
var ZoomOut = next_dynamic__WEBPACK_IMPORTED_MODULE_1___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(14869), __webpack_require__.e(30730)]).then(__webpack_require__.bind(__webpack_require__, 30730));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(30730)
            ];
        }
    }
});
var Animated = function(props) {
    switch(props.type){
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isReveal */ .BK.isReveal:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Reveal, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isFade */ .BK.isFade:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Fade, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCustom */ .BK.isCustom:
            {
                if (Object.keys(props).length === 1) {
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    });
                }
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CustomAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isJSON */ .BK.isJSON:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(JSONAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isParallaxSpring */ .BK.isParallaxSpring:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ParallaxWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.imageZoom */ .BK.imageZoom:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageZoom, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.gsap */ .BK.gsap:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Gsap, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.expandByHeight */ .BK.expandByHeight:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ExpandWrapper, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.isCSS */ .BK.isCSS:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CSSAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.bounce */ .BK.bounce:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Bounce, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        children: props.children
                    })
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.counter */ .BK.counter:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CounterAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        case utils_constants__WEBPACK_IMPORTED_MODULE_2__/* .ANIMATED_TYPE.zoomOut */ .BK.zoomOut:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ZoomOut, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
        default:
            {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ScrollAnimation, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, props), {
                    children: props.children
                }));
            }
    }
};
/* harmony default export */ __webpack_exports__["default"] = (Animated);


/***/ }),

/***/ 27:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ sections_TableSection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./UI/components/SectionTitle/index.jsx + 1 modules
var SectionTitle = __webpack_require__(36837);
// EXTERNAL MODULE: ./UI/containers/Animated/index.jsx
var Animated = __webpack_require__(61971);
// EXTERNAL MODULE: ./utils/constants.js
var constants = __webpack_require__(96076);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(6572);
;// CONCATENATED MODULE: ./UI/sections/TableSection/utils/useSectionProps.js


/* harmony default export */ function useSectionProps(param) {
    var section = param.section, type = param.type;
    var ref = (0,helper/* getDocumentFields */.OA)(section, [
        "title",
        "description",
        "subtitle",
        "view",
        "contentModules", 
    ]), title = ref.title, description = ref.description, subtitle = ref.subtitle, view = ref.view, contentModules = ref.contentModules;
    var ref1 = (0,helper/* getDocumentFields */.OA)(get_default()(contentModules, "[0]", []), [
        "tableContent",
        "tableType"
    ]), tableContent = ref1.tableContent, tableType = ref1.tableType;
    return {
        title: title,
        description: description,
        subtitle: subtitle,
        view: view,
        type: type,
        tableContent: tableContent,
        tableType: tableType
    };
};

// EXTERNAL MODULE: ./UI/sections/TableSection/styles.module.scss
var styles_module = __webpack_require__(61582);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./UI/sections/TableSection/index.jsx












var Table = dynamic_default()(function() {
    return __webpack_require__.e(/* import() */ 84045).then(__webpack_require__.bind(__webpack_require__, 84059));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(84059)
            ];
        }
    }
});
var TableSection = function(props) {
    var ref = useSectionProps(props), title = ref.title, description = ref.description, subtitle = ref.subtitle, view = ref.view, type = ref.type, tableContent = ref.tableContent, tableType = ref.tableType;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
        className: classnames_default()((styles_module_default()).tableSection, (styles_module_default())[type], (styles_module_default())[view]),
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: (styles_module_default()).contentWrapper,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(SectionTitle["default"], {
                    title: title,
                    subtitle: subtitle,
                    description: description,
                    titleStyle: (styles_module_default()).titleStyle
                }),
                tableContent && tableType && /*#__PURE__*/ (0,jsx_runtime.jsx)(Animated["default"], (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, constants/* REVEAL_ANIMATION_PROPS */.kt), {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (styles_module_default()).tableWrapper,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Table, {
                            tableData: tableContent.tableData,
                            type: tableType
                        })
                    })
                }))
            ]
        })
    });
};
TableSection.propTypes = {
    section: prop_types_default().instanceOf(Object).isRequired,
    type: (prop_types_default()).string.isRequired
};
/* harmony default export */ var sections_TableSection = (TableSection);


/***/ }),

/***/ 19341:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bw": function() { return /* binding */ selectIsSmallTablet; },
/* harmony export */   "Tr": function() { return /* binding */ selectIsPageReadyToDisplay; },
/* harmony export */   "Y6": function() { return /* binding */ selectIsDesktop; },
/* harmony export */   "aT": function() { return /* binding */ selectIsTablet; },
/* harmony export */   "cF": function() { return /* binding */ selectIsFirstPageLoaded; },
/* harmony export */   "eD": function() { return /* binding */ selectIsMobile; },
/* harmony export */   "qL": function() { return /* binding */ selectIsMobileCategotiesOpened; }
/* harmony export */ });
var selectIsMobileCategotiesOpened = function(state) {
    return state.layout.isMobileCategotiesOpened;
};
var selectIsPageReadyToDisplay = function(state) {
    return state.layout.isPageReadyToDisplay;
};
var selectIsFirstPageLoaded = function(state) {
    return state.layout.isFirstPageLoaded;
};
var selectIsMobile = function(state) {
    return state.layout.isMobileResolution;
};
var selectIsTablet = function(state) {
    return state.layout.isTabletResolution;
};
var selectIsSmallTablet = function(state) {
    return state.layout.isSmallTabletResolution;
};
var selectIsDesktop = function(state) {
    return state.layout.isDesktopResolution;
};


/***/ }),

/***/ 89494:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"sectionTitleContainer":"styles_sectionTitleContainer__YEeiB","title":"styles_title__m075V","subtitle":"styles_subtitle__2fL8O","description":"styles_description__WuHDh","default":"styles_default__R0jjX","side":"styles_side___qNH3"};

/***/ }),

/***/ 34461:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"boldText":"styles_boldText__iI9uz","headline-xl":"styles_headline-xl__HRBMS","headline-l":"styles_headline-l__Veh_x","headline-m":"styles_headline-m__gfh2N","headline-s":"styles_headline-s___kodX","headline-xs":"styles_headline-xs__XhN56","paragrapgh-m":"styles_paragrapgh-m__QFKni","paragrapgh-s":"styles_paragrapgh-s__4Eq1X","caption":"styles_caption__y7HHJ"};

/***/ }),

/***/ 61582:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"cardsWithFullWidthImage":"styles_cardsWithFullWidthImage__5a7V_","cards":"styles_cards__NXnDu","imageWrapper":"styles_imageWrapper__iej0W","typeTitle":"styles_typeTitle__SRqTQ","greySection":"styles_greySection__7aJcx","callToAction":"styles_callToAction__KuX1_","threeColumnsCards":"styles_threeColumnsCards__I6GB5","twoColumnsCards":"styles_twoColumnsCards__Au0fY","textContent":"styles_textContent__ceTEk","tableSection":"styles_tableSection__kXbXB","contentWrapper":"styles_contentWrapper__Q0dOq","tableWrapper":"styles_tableWrapper__hTmKi","penetration-testing":"styles_penetration-testing__7q5CL","titleStyle":"styles_titleStyle__R4OXE","software-development-engagement-models":"styles_software-development-engagement-models__wRV1d"};

/***/ })

}]);